<template>
    <el-dialog
    title="选择软件"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="80rem">
    <examine-score-detail ref="examine_score_detail"></examine-score-detail>
        <div class="soft-box">
            <Table :totalSize="tableData.length" :pagination="false" :operationWidth="350" :currentPage="pages.current"
                :pageSize="pages.size" navHeight=40 ref="table"
                        :tableData="tableData" :tableKey="tableKey">
                <template slot="operation" slot-scope="data">
                    <div class="btn-button" @click="viewScoreDetail(data.data.row)">查看详情</div>      
                </template>
            </Table>
        </div>
    </el-dialog>
</template>

<script>
import { GetSoftwareScoreTree } from '@/api/examine';
import ExamineScoreDetail from './ExamineScoreDetail.vue';
    export default {
  components: {ExamineScoreDetail  },
        data(){
            return {
                dialogVisible:false,
                tableData:[],
                /**任务Id */
                taskId:'',
                pages:{
                    current:1,
                    size:10,
                },
                optSource:'',
                tableKey:[
                    {
                        name:'软件名称',
                        value:'softwareName'
                    },
                    {
                        name:'软件类型',
                        value:'resType'
                    },
                    {
                        name:'',
                        value:'operation',
                        slot:'operation'
                    },
                ]
            }
        },
        methods:{
            /**查看得分详情 */
            viewScoreDetail(item){
                let params={
                    examineId:this.taskId,
                    softwareId:item.id,
                    userId:this.$store.state.user.userInfo.id
                }
                GetSoftwareScoreTree(params).then(res=>{
                let dialog=this.$refs.examine_score_detail;
                if(dialog){
                    dialog.dialogVisible=true;
                    dialog.detail=res.data;

                }
            });
            }
        }
    }
</script>

<style lang="less" scoped>
.soft-box{
    height: 50rem;
    overflow: auto;
}
.btn-button {
    width: 72px;
    height: 26px;
    background: var(--blue);
    border-radius: 0.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    cursor: pointer;
}
/deep/.el-dialog{
    border-radius: 1rem;
}
/deep/.el-dialog__header{
    font-weight: 700;
    padding: 3rem 5rem;
}
/deep/.el-dialog__body {
    padding: 0 3rem 5rem 3rem;
}
</style>